var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalmartIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 50",
    width: 23.5,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.548721,17.863708c1.023743,0 1.866257,-0.532471 1.979996,-1.219971l1.011261,-11.430054c0,-1.130005 -1.32251,-2.057495 -2.987503,-2.057495c-1.662506,0 -2.983749,0.92749 -2.983749,2.057495l1.008743,11.430054c0.112503,0.6875 0.955002,1.219971 1.975006,1.219971l-0.003998,0",
    id: "path2974",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.371231,21.433716c0.513748,-0.88501 0.473755,-1.881226 -0.066193,-2.32251l-9.395004,-6.589966c-0.976303,-0.565002 -2.441299,0.116211 -3.272552,1.557495c-0.833755,1.438721 -0.686249,3.047485 0.288742,3.612488l10.40126,4.84375c0.651245,0.241272 1.537491,-0.222534 2.047501,-1.107483l-0.003998,0.005981",
    id: "path2976",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.731232,21.42749c0.512497,0.88501 1.395004,1.348755 2.046249,1.107483l10.402496,-4.84375c0.980011,-0.565002 1.12001,-2.173706 0.292511,-3.612488c-0.835007,-1.441223 -2.302505,-2.122499 -3.27626,-1.557495l-9.395004,6.590027c-0.537491,0.441223 -0.577499,1.4375 -0.066193,2.322449l-0.003998,-0.005981",
    id: "path2978",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.548721,32.140015c1.023743,0 1.866257,0.528748 1.979996,1.216248l1.011261,11.428772c0,1.132507 -1.32251,2.058716 -2.987503,2.058716c-1.662506,0 -2.983749,-0.926208 -2.983749,-2.058716l1.008743,-11.428772c0.112503,-0.6875 0.955002,-1.216248 1.975006,-1.216248l-0.003998,0",
    id: "path2980",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m29.731232,28.570007c0.512497,-0.88623 1.395004,-1.347473 2.046249,-1.102478l10.402496,4.838745c0.980011,0.566223 1.12001,2.176208 0.292511,3.617493c-0.835007,1.436218 -2.302505,2.118713 -3.27626,1.554993l-9.395004,-6.58374c-0.537491,-0.446289 -0.577499,-1.442505 -0.066193,-2.326233l-0.003998,0.000977",
    id: "path2982",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.371231,28.568726c0.513748,0.883728 0.473755,1.880005 -0.066193,2.326233l-9.395004,6.58374c-0.976257,0.563782 -2.441254,-0.118713 -3.272507,-1.554993c-0.833801,-1.441223 -0.686295,-3.051208 0.288696,-3.617493l10.40126,-4.838745c0.651245,-0.244995 1.53749,0.216248 2.047502,1.102478l-0.003998,-0.000977",
    id: "path2984",
    fillRule: "nonzero",
    fill: "#fdbb30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartIcon2);
export default __webpack_public_path__ + "static/media/walmart-icon_2.96202ba65c13fb1b3779f384f7dc06e8.svg";
export { ForwardRef as ReactComponent };